import { EMAIL_REGEX } from '@kentik/ui-shared/util/regex';

export default {
  message: 'Enter a comma separated list of valid email addresses',
  fn: (value) => value && value.split(',').every((email) => email.trim().match(EMAIL_REGEX))
};
